export class FetchError extends Error {
  constructor() {
    super("fetch error");
  }
}
